<template>
  <div class="content">
    <div class="user-management">
      <div class="row">
        <div class="col-md-12">
          <div style="margin-top: 20px">
            <template>
              <div class="header-actions">
                <h5 class="title">Public Holidays</h5>
                <div v-if="isAdmin" class="actions-right">
                  <button class="add-employee" @click="openHolidayModal()">
                    <span>Add Holiday</span>
                  </button>
                </div>
              </div>
            </template>

            <div>
              <CustomTable defaultSortKey="dates" :header="filteredColumns" :loading="loadingStates.table" :columns="filteredColumns" :data="holidayList">
                <template v-slot:fileName="{ item }">
                  <span class="truncate-text" :title="item.name || '-'">
                    {{ item.name || '-' }}
                  </span>
                </template>

                <template v-slot:dates="{ item }">
                  <span class="truncate-text">
                    {{ formatDate(item.dates, !item.isRecurring, item.numberOfDays) }}
                  </span>
                </template>

                <template v-slot:isRecurring="{ item }">
                  <span class="truncate-text">
                    {{ item.isRecurring ? "Recurring" : "One-time" }}
                  </span>
                </template>

                <template v-slot:shift="{ item }">
                  <span class="truncate-text">{{ item.shift || "-" }}</span>
                </template>

                <template v-slot:numberOfDays="{ item }">
                  <span>
                    {{ item.numberOfDays ? item.numberOfDays + (item.numberOfDays > 1 ? " days" : " day") : "-" }}
                  </span>
                </template>

                <template v-if="isAdmin" v-slot:action="{ item }">
                  <div class="action-buttons">
                    <button class="edit-btn btn-status" :title="'Edit'" @click="editHoliday(item)">
                      <PencilIcon color="gray" :width="16" :height="16" />
                    </button>

                    <button class="delete-btn btn-status" title="Delete" @click="openDeleteModal(item)">
                      <i class="fa fa-trash" style="color: gray;"></i>
                    </button>
                  </div>
                </template>
              </CustomTable>
            </div>
          </div>

          <ReuseableModal :modelValue="isHolidayModalOpen" @update:modelValue="isHolidayModalOpen = $event"
            :title="this.selectedHoliday ? 'Edit Holiday' : 'Add Holiday'" :isLarge="false" submitButtonText="Save"
            @submit="saveHoliday()" :loading="loadingStates.save">
            <form @submit.prevent="saveHoliday()">
              <div class="form-group row">
                <div class="col-md-12" style="margin-bottom: 20px;">
                  <label for="name">Holiday Name <span style="color: red; font-size: 14px;">*</span></label>
                  <input type="text" id="name" class="form-control" placeholder="Enter Holiday Name" v-model="name" />
                  <span v-if="nameError" class="text-danger">{{ nameError }}</span>
                </div>

                <div class="col-md-6" style="margin-bottom: 20px;">
                  <label for="dates">Date <span style="color: red; font-size: 14px;">*</span></label>
                  <input type="date" id="dates" class="form-control" v-model="dates" required />
                  <span v-if="dateError" class="text-danger">{{ dateError }}</span>
                </div>
                <div class="col-md-6" style="margin-bottom: 20px;">
                  <label for="days">Number of Days</label>
                  <input type="number" id="days" class="form-control" v-model.number="numberOfDays" min="1"
                    @input="onDaysInput" required />
                </div>

                <div class="col-md-6">
                <CustomDropdown id="shift-dropdown" label="Shift" :options="shiftOptions" :value="shift" placeholder="Select Shift" @change="shift = $event" />
                </div>

                <div class="checkbox-box col-md-6 public-holiday-checbox">
                  <input type="checkbox" class="checkbox" style="width: 15px; height: 15px; margin-bottom: 2px;"
                    id="recurring" v-model="isRecurring" />
                  <label for="recurring">Recurring yearly</label>
                </div>
              </div>
            </form>
          </ReuseableModal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert";
import CustomTable from "src/components/UIComponents/CustomTable.vue";
import Card from "src/components/UIComponents/Cards/Card.vue";
import PencilIcon from 'src/assets/icons/PencilIcon.js';
import ReuseableModal from "src/components/UIComponents/ReuseableModal.vue";
import { formatHolidayDate } from "@/utils/fileUtils";
import firebase from "../../../../assets/config/firebase";
import CustomDropdown from '../../../UIComponents/CustomDropdown.vue';

export default {
  components: {
    Card,
    CustomTable,
    PencilIcon,
    ReuseableModal,
    CustomDropdown,
  },
  props: {
    isAdmin: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      tableColumns: [
        { label: "Holiday Name", key: "name", sortable: true, width: 180, sticky: "left" },
        { label: "Date", key: "dates", sortable: true },
        { label: "Type", key: "isRecurring", sortable: true },
        { label: "Shift", key: "shift", sortable: true },
        { label: "Days", key: "numberOfDays", sortable: true },
        { label: "Action", key: "action", sticky: "right" }
      ],

      holidayList: [],
      selectedHoliday: null,
      isHolidayModalOpen: false,

      name: "",
      dates: "",
      numberOfDays: 1,
      isRecurring: false,
      shift: "General",

      shiftOptions: ["General", "Morning", "Night"],

      nameError: "",
      dateError: "",

      loadingStates: {
        table: false,
        save: false,
        delete: false
      },
    };
  },

  computed: {
    filteredColumns() {
      return this.isAdmin
        ? this.tableColumns
        : this.tableColumns.filter(col => col.key !== "action");
    }
  },

  mounted() {
    this.fetchHolidays();
  },

  methods: {
    formatDate(dateStr, oneTime, numberOfDays) {
      return formatHolidayDate(dateStr, oneTime, numberOfDays);
    },

    openHolidayModal() {
      this.resetForm();
      this.isHolidayModalOpen = true;
    },

    editHoliday(item) {
      this.selectedHoliday = item;
      this.name = item.name;
      this.dates = item.dates;
      this.numberOfDays = item.numberOfDays;
      this.isRecurring = item.isRecurring;
      this.shift = item.shift || "General";
      this.isHolidayModalOpen = true;
    },

    onDaysInput(event) {
      const value = Number(event.target.value);

      if (value < 1 || !value) {
        this.numberOfDays = 1;
      }
    },

    resetForm() {
      this.name = "";
      this.dates = "";
      this.numberOfDays = 1;
      this.isRecurring = false;
      this.shift = "General";
      this.selectedHoliday = null;
    },

    async saveHoliday() {
      if (!this.name) {
        this.nameError = "Holiday name is required";
        return;
      }
      this.nameError = "";
      if (!this.dates) {
        this.dateError = "Date is required";
        return;
      }
      this.dateError = "";
      const payload = {
        name: this.name,
        dates: this.dates,
        numberOfDays: this.numberOfDays,
        isRecurring: this.isRecurring,
        shift: this.shift
      };

      try {
        this.loadingStates.save = true;

        if (this.selectedHoliday) {
          await firebase.updateHoliday(this.selectedHoliday.uid, payload);
          this.fetchHolidays()
          swal("Holiday updated", "Updated", "success");
        } else {
          await firebase.addHoliday(payload);
          this.fetchHolidays()
          swal("Holiday added", "Added", "success");
        }

        this.isHolidayModalOpen = false;
      } catch (err) {
        swal("Error", err.message || "Something went wrong", "error");
      } finally {
        this.loadingStates.save = false;
      }
    },

    openDeleteModal(item) {
      this.selectedHoliday = item;
      swal({
        title: "Are you sure?",
        text: "This holiday will be permanently deleted.",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          await this.deleteHoliday();
        }
      });
    },

    async deleteHoliday() {
      try {
        this.loadingStates.delete = true;
        await firebase.deleteHoliday(this.selectedHoliday.uid);
        this.fetchHolidays()
        swal("Holiday deleted", "Deleted", "success");
      } catch (err) {
        swal("Delete failed", err.message || "Could not delete", "error");
      } finally {
        this.loadingStates.delete = false;
      }
    },

    async fetchHolidays() {
      this.loadingStates.table = true;
      try {
        const holidays = await firebase.getAllHolidays()

        const user = this.$store.state.auth.user;
        const role = user.role;
        const userShift = (user.shift || "morning").toLowerCase();
        if (role === "admin") {
          this.holidayList = holidays;
          return;
        }

        this.holidayList = holidays.filter(h => {
          const hShift = (h.shift || "morning").toLowerCase();

          if (hShift === "general") return true;
          if (userShift === "morning" && hShift === "morning") return true;
          if (userShift === "night" && hShift === "night") return true;

          return false;
        });
      } catch (err) {
        swal("Fetch failed", "Could not load holidays", "error");
      } finally {
        this.loadingStates.table = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PublicHoliday/PublicHoliday.vue